/**
 * pt-BR formatting for cranial measurements. Pure helpers, no React.
 * Every formatter returns "—" for missing or non-finite values.
 */

const EMPTY = "—";

const isFiniteNumber = (value) => typeof value === "number" && Number.isFinite(value);

const formatNumber = (value, fractionDigits) =>
  value.toLocaleString("pt-BR", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

/** 123.4 -> "123 px" */
export const formatPx = (value) => (isFiniteNumber(value) ? `${formatNumber(value, 0)} px` : EMPTY);

/** 12.34 -> "12,3 mm"; 154.8 -> "15,48 cm" (centimeters from 100 mm on). */
export const formatMm = (value) => {
  if (!isFiniteNumber(value)) return EMPTY;
  if (Math.abs(value) >= 100) return `${formatNumber(value / 10, 2)} cm`;
  return `${formatNumber(value, 1)} mm`;
};

/** 82.53 -> "82,5 %" */
export const formatIndex = (value) => (isFiniteNumber(value) ? `${formatNumber(value, 1)} %` : EMPTY);

/** CVA is a linear distance: millimeters when calibrated, otherwise pixels. */
export const formatCva = (mm, px) => (isFiniteNumber(mm) ? formatMm(mm) : formatPx(px));

/** 0.81 -> "81 %" */
export const formatConfidence = (value) =>
  isFiniteNumber(value) ? `${formatNumber(value * 100, 0)} %` : EMPTY;
